module.exports = __webpack_public_path__ + "img/search.f23bb0a3.svg";